var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCertificacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88.13 88.13",
    style: {
      enableBackground: "new 0 0 88.13 88.13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_112_",
    className: "st0",
    d: "M44.06,0.56c-23.99,0-43.5,19.51-43.5,43.5c0,23.98,19.51,43.5,43.5,43.5 c23.99,0,43.5-19.52,43.5-43.5C87.56,20.08,68.05,0.56,44.06,0.56z M44.06,80.39c-20.03,0-36.33-16.3-36.33-36.33 c0-20.03,16.3-36.33,36.33-36.33c20.03,0,36.33,16.3,36.33,36.33C80.39,64.1,64.1,80.39,44.06,80.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.68,15.71H52.4l-6.65,9.51l5.13,7.33L62.68,15.71z M62.68,15.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.75,36.71v-1.75h3.45L35.73,15.71H25.45l13.48,19.25h3.46v1.75c-9.09,0.85-16.22,8.51-16.22,17.81 c0,9.86,8.02,17.9,17.9,17.9c9.87,0,17.9-8.04,17.9-17.9C61.97,45.22,54.83,37.56,45.75,36.71L45.75,36.71z M44.07,69.56 c-8.3,0-15.03-6.75-15.03-15.03c0-8.29,6.74-15.03,15.03-15.03c8.29,0,15.03,6.74,15.03,15.03C59.1,62.81,52.36,69.56,44.07,69.56 L44.07,69.56z M44.07,69.56"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 44.07,
    cy: 54.52,
    r: 13.28
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertificacion);
export default __webpack_public_path__ + "static/media/icon-certificacion.e8e34a9ef91f287a07ecffc97e7a78f6.svg";
export { ForwardRef as ReactComponent };